import React from "react";
import { chosenTheme } from "../../theme";

export default function WIDOperations() {
  const theme = chosenTheme;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="602.10668"
      height="696.91865"
      viewBox="0 0 602.10668 696.91865"
      role="img"
      artist="Katerina Limpitsouni"
      source="https://undraw.co/"
    >
      <path
        d="M901.05334,367.54068q0,2.97-.07,5.93c-.02,1.29-.06,2.58-.11,3.87-.01.37-.02.73-.04,1.1q-.045,1.065-.09,2.1-.33,6.915-1.02,13.73c-.02.22-.04.44-.06.65-.05.45-.09.9-.15,1.35-.14,1.35-.29,2.7-.46,4.03-.11.9-.22,1.79-.34,2.69-.06.43-.12.86-.17,1.28-.07.47-.13.93-.2,1.39-.03.2-.06.4-.09.61-.1.68-.2,1.37-.31,2.05-.13.89-.27,1.77-.42,2.66q-.20994,1.32-.45,2.63995c-.15.88-.31,1.76-.47,2.64-.16.89-.33,1.77-.5,2.65q-1.29,6.54-2.88,12.97-.63,2.50507-1.29,5-1.095,4.05-2.31,8.06c-.23.74005-.46,1.48-.69,2.21-.26.84-.53,1.68-.8,2.51-.27.84-.54,1.67-.82,2.5-.28.83-.56,1.66-.85,2.49-.28.82-.56995,1.65-.87,2.47-.29.83-.59,1.65-.89,2.47-.31.82-.61,1.64-.92,2.45q-.93,2.46-1.91,4.87c-.32.81-.65,1.62-.99,2.42q-1.995,4.83006-4.18,9.55c-.32.7-.64,1.4-.97,2.09-.22.46-.43.91-.65,1.37-.37006.76-.73,1.51-1.1,2.26-.37.76-.75,1.53-1.14,2.3q-1.15494,2.28-2.35,4.55c-.79,1.51-1.6,3.02-2.43,4.51s-1.67,2.98-2.52,4.45c-.43.74-.86,1.48-1.29,2.21q-2.59506,4.39509-5.36,8.69-2.745,4.275-5.67,8.45c-.97,1.39-1.96,2.78-2.96,4.15-.4.55-.80005,1.09-1.2,1.63-.49.68-1,1.35-1.51,2.02a265.809,265.809,0,0,1-382.97,44.18q-4.38007-3.66-8.6-7.5a267.37572,267.37572,0,0,1-46.71-55.98c-1.61-2.59-3.18994-5.21-4.71-7.85a264.766,264.766,0,0,1-35.51-132.87c0-146.91,119.09-266,266-266a265.77735,265.77735,0,0,1,222.68,120.44c.44.67.88,1.35,1.32,2.03a264.422,264.422,0,0,1,41.33,124.62Q901.05838,357.99063,901.05334,367.54068Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#f2f2f2"
      />
      <path
        d="M859.05334,224.01065h-368.45a1.0153,1.0153,0,0,1,0-2.03h367.13C858.17333,222.65066,858.61334,223.33065,859.05334,224.01065Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#cacaca"
      />
      <ellipse
        cx="214.01047"
        cy="97.09031"
        rx="10.92534"
        ry="11.16881"
        fill={theme.text}
      />
      <ellipse
        cx="251.75254"
        cy="97.09031"
        rx="10.92534"
        ry="11.16881"
        fill={theme.text}
      />
      <ellipse
        cx="289.49462"
        cy="97.09031"
        rx="10.92534"
        ry="11.16881"
        fill={theme.text}
      />
      <path
        d="M900.38335,348.63064c-9.61,4.37-18.22,11.43-25.74,21.14-8.69,11.23-18,19.14-27.51,24.5-.45.25-.89.49-1.34.73a73.52807,73.52807,0,0,1-27.51,8.43005,83.49856,83.49856,0,0,1-8.76.42c-1.22-.01-2.43994-.04-3.65-.1-2.87-.14-5.71-.42-8.5-.81995-16.02-2.28-30.51-8.44-41.24-14.23a150.08806,150.08806,0,0,0-47.21-16.52q-4.44-.73508-8.86-1.15c-1.22-.12-2.43-.21-3.64-.29q-4.455-.3-8.9-.28c-1.52.01-3.03.04-4.55.1-25.54,1-58.85,8.28-88.72,33.71-.4.34-.79.68-1.19,1.02-.37.32-.74.65-1.11.98a149.14345,149.14345,0,0,0-13.34,13.47,169.08964,169.08964,0,0,0-13.2,17.25,110.05552,110.05552,0,0,1-16.64,19.3,92.67742,92.67742,0,0,0-29.82,67.12v.5c-.01.54-.01,1.09-.01,1.63h330.13c.4-.54.8-1.08,1.19-1.63,1-1.37,1.99-2.76,2.96-4.15q2.925-4.17,5.67-8.45,2.775-4.29,5.36-8.69c.43-.73.86-1.47,1.29-2.21.85-1.47,1.69-2.96,2.52-4.45s1.64-3,2.43-4.51q1.2-2.265,2.35-4.55c.39-.77.77-1.54,1.14-2.3.37-.75.73-1.5,1.1-2.26.22-.46.43-.91.65-1.37.33-.69.65-1.39.97-2.09q2.18994-4.72494,4.18-9.55c.34-.8.67-1.61.99-2.42q.97494-2.415,1.91-4.87c.31-.81.61-1.63.92-2.45.3-.82.6-1.64.89-2.47.3-.81994.59-1.65.87-2.47.29-.83.57-1.66.85-2.49.28-.83.55-1.66.82-2.5.27-.83.54-1.67.8-2.51.23-.73.46-1.47.69-2.21q1.215-4.005,2.31-8.06.66-2.49,1.29-5,1.59-6.42,2.88-12.97c.17-.88.34-1.76.5-2.65.16-.88.32-1.76.47-2.64q.24-1.31991.45-2.63995c.15-.89.29-1.77.42-2.66.11-.68.21-1.37.31-2.05.03-.21.06-.41.09-.61.07-.47.13-.93.19-1.39.06-.43.12-.86.18-1.28.12006-.9.23-1.79.34-2.69.17-1.33.32-2.68006.46-4.03h.01c.04-.45.09-.9.14-1.35.02-.21.04-.43.06-.65q.69-6.81,1.02-13.73.045-1.035.09-2.1c.02-.37.03-.73.04-1.1.05-1.29.09-2.58.11-3.87q.075-2.955.07-5.93Q901.05334,358.0007,900.38335,348.63064Z"
        transform="translate(-298.94666 -101.54068)"
        fill={theme.imageHighlight}
      />
      <rect
        x="288.24439"
        y="314.1553"
        width="3.64845"
        height="106.93902"
        fill={theme.text}
      />
      <rect
        x="397.47305"
        y="264.21087"
        width="3.64845"
        height="156.88345"
        fill={theme.text}
      />
      <rect
        x="506.92662"
        y="297.04694"
        width="3.64845"
        height="124.04738"
        fill={theme.text}
      />
      <circle cx="399.52225" cy="266.72558" r="11.1612" fill={theme.text} />
      <circle cx="508.97582" cy="297.73743" r="11.1612" fill={theme.text} />
      <circle cx="288.06868" cy="305.15546" r="11.1612" fill={theme.text} />
      <path
        d="M850.26336,523.91067c-.4.55-.80005,1.09-1.2,1.63-.49.68-1,1.35-1.51,2.02h-328.97v-3.65Z"
        transform="translate(-298.94666 -101.54068)"
        fill={theme.text}
      />
      <polygon
        points="127.115 685.125 137.686 685.125 142.715 644.349 127.113 644.35 127.115 685.125"
        fill="#ffb8b8"
      />
      <path
        d="M453.56335,787.10067a13.13965,13.13965,0,0,0-4.3-2.89,13.41155,13.41155,0,0,0-5.08-1l-6.23-4.72-.33.12994-11.28,4.59h-2.98v13.7h34.09v-.43A13.16046,13.16046,0,0,0,453.56335,787.10067Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#2f2e41"
      />
      <polygon
        points="176.228 685.125 186.799 685.125 191.828 644.349 176.226 644.35 176.228 685.125"
        fill="#ffb8b8"
      />
      <path
        d="M502.68334,787.10067a13.07676,13.07676,0,0,0-4.31-2.89,13.33568,13.33568,0,0,0-5.08-1l-6.22-4.72-.34.13995-11.28,4.58h-2.98l.01,13.7h34.08v-.43A13.19238,13.19238,0,0,0,502.68334,787.10067Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#2f2e41"
      />
      <path
        d="M483.62462,563.52211,400.566,565.68885l1.4445,40.44594s-1.4445,10.83373,1.4445,13.72273,4.33349,2.889,2.889,7.94473,6.18746,13.31327,5.26048,14.24025-3.09373,5.98272-3.09373,5.98272l7.22249,41.16818s5.05574,71.50264,6.50024,72.94714,2.889,0,1.4445,3.61124-2.889,2.16675-1.4445,3.61125a53.19157,53.19157,0,0,1,3.61124,4.33349h17.46193s1.31654-7.22249,1.31654-7.94474,1.4445-5.05574,1.4445-5.778-1.27673-1.999-1.27673-1.999a23.76122,23.76122,0,0,1-.89-4.50126c0-1.4445-4.33349-57.05766-4.33349-57.05766l8.667-72.22488,20.94521,70.78039s0,62.1134,1.4445,63.55789,1.4445.72225.72225,3.61125-3.61125,2.16674-1.4445,4.33349,2.889-1.4445,2.16675,2.16675l-.72225,3.61124,21.66746.30994s2.889-6.08793,1.4445-8.25468-1.35783-1.57529.40446-5.12114,2.48454-4.26809,1.76229-4.99034-.72225-4.56382-.72225-4.56382l-3.61124-69.10556s-.72225-72.94714-.72225-75.11388a7.20412,7.20412,0,0,1,.6-3.24922v-2.94108l-2.76672-10.42143Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#2f2e41"
      />
      <path
        d="M577.62138,405.99776a8.0652,8.0652,0,0,1-11.60959,4.2615l-36.05395,30.20512-1.9594-14.7643,35.26391-26.99494a8.1089,8.1089,0,0,1,14.359,7.29262Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#ffb8b8"
      />
      <circle cx="119.69646" cy="294.5335" r="22.38971" fill="#ffb8b8" />
      <path
        d="M436.79441,373.79162c-2.08444-4.96819-11.01748-7.918-25.15293-7.47373s-16.61088,17.301-16.61088,17.301c-7.7858,7.25682,4.78422,29.91414,6.965,26.79028,2.18079-3.1238,5.84226-.17106,5.84226-.17106l-3.48932-19.62672c3.68483,1.41758,7.6478,2.36941,11.11371.71789l-5.74252-3.07069,14.27815,1.77674-5.88836-4.53c.14274-.04712.28548-.09608.4283-.14415a20.92449,20.92449,0,0,0,7.45992,1.6937c3.002-.02239,6.19233-1.42914,7.4503-4.15495a6.13852,6.13852,0,0,0,.53276-2.3761c4.13923,1.34387,6.31262,6.19288,6.31262,6.19288A76.40324,76.40324,0,0,0,436.79441,373.79162Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#2f2e41"
      />
      <path
        d="M436.56515,419.4653c-5,0-8.22.69-16,2-14.36,2.42-5.76,16.06452-5.76,16.06452s.65-.33-1.11,0-7.76,5.52-7.76,5.52l-10.73,9.53c-16.17,12.69-12.55,32.49-12.55,32.49l23.58,23.73-10.33,47.61s4.38995,7.07,2.11993,10.24,20,2.26,20,2.26c15.37,6.85,69.52,1.06,69.52,1.06-.75-1.96-8-17.15-8-17.15,3.15-5.44.15-13.3.15-13.3s-3.13-37.18-5.13-42.32,5.12-32.99,9.8-32.69,34.91-15.12,34.91-15.12-.76-1.21,9.22-5.29a48.91136,48.91136,0,0,0,15.49-9.77l4.1-8.19c-1.97.76-8.62-11.78-8.62-11.78l-2.9,1.1055-1.68005-.4855s-13.11,3.73-15.79,6.45-3.58,1.96-6,2.57-2.72,2.31-3.48,2.12-2.11,2.11-3.17,1.81-3.33.91-4.84,1.21-12.24,4.84-12.24,4.84c-6.64-3.36-24.64-2-24.64-2s-5.89-3.47-7.56,0a5.68994,5.68994,0,0,1-5.13,3.33l-7.18-3.07C444.43783,433.763,436.60616,417.8865,436.56515,419.4653Z"
        transform="translate(-298.94666 -101.54068)"
        fill={theme.text}
      />
      <path
        d="M356.27789,742.53077l-.99775-22.43416a72.45542,72.45542,0,0,0-33.79563-8.555c16.23147,13.27042,14.203,38.85124,25.20758,56.69681a43.58207,43.58207,0,0,0,31.95921,20.13989l13.58307,8.31648A73.02983,73.02983,0,0,0,376.84153,737.516a70.54266,70.54266,0,0,0-12.96441-12.04607C360.624,734.04788,356.27789,742.53077,356.27789,742.53077Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#f2f2f2"
      />
      <path
        d="M298.94666,797.26932a1.18647,1.18647,0,0,0,1.19007,1.19h283.29a1.19,1.19,0,1,0,0-2.38h-283.29A1.18651,1.18651,0,0,0,298.94666,797.26932Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#ccc"
      />
      <rect
        x="289.49437"
        y="302.72949"
        width="6"
        height="2"
        fill={theme.text}
      />
      <path
        d="M606.55334,404.27066v2h12.12v-2Zm24.24,0v2h12.11v-2Zm24.23,0v2h12.12v-2Zm24.23,0v2h12.12v-2Zm24.24,0v2h12.11v-2Zm24.23,0v2h12.12v-2Zm24.23,0v2h12.12v-2Zm24.24,0v2h12.11v-2Zm24.23,0v2h12.12v-2Zm24.23,0v2h12.12v-2Zm24.23,0v2h12.12v-2Zm24.24,0v2h12.11v-2Zm24.23,0v2h.9c.03-.21.06-.41.09-.61.07-.46.13-.92.2-1.39Z"
        transform="translate(-298.94666 -101.54068)"
        fill={theme.text}
      />
      <rect
        x="393.49437"
        y="262.72949"
        width="6"
        height="2"
        fill={theme.text}
      />
      <path
        d="M710.55334,364.27066v2h12.12v-2Zm24.24,0v2h12.11v-2Zm24.23,0v2h12.12v-2Zm24.23,0v2h12.12v-2Zm24.24,0v2h12.11v-2Zm24.23,0v2h12.12v-2Zm24.23,0v2h12.12v-2Zm24.24,0v2h12.11v-2Z"
        transform="translate(-298.94666 -101.54068)"
        fill={theme.text}
      />
      <rect
        x="504.49437"
        y="292.72949"
        width="6"
        height="2"
        fill={theme.text}
      />
      <path
        d="M821.55334,394.27066v2h12.12v-2Zm24.24,0v2h12.11v-2Zm24.23,0v2h12.12v-2Zm24.23,0v2h5.27c.04-.45.09-.9.14-1.35.02-.21.04-.43.06-.65Z"
        transform="translate(-298.94666 -101.54068)"
        fill={theme.text}
      />
      <path
        d="M452.05334,602.84962V538.44017a4.92267,4.92267,0,0,1,4.9171-4.91711h48.64344a4.92266,4.92266,0,0,1,4.91708,4.91711v64.40945a4.92266,4.92266,0,0,1-4.91708,4.9171H456.97044A4.92267,4.92267,0,0,1,452.05334,602.84962Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#e6e6e6"
      />
      <path
        d="M455.78459,583.39527V541.987a4.61014,4.61014,0,0,1,4.605-4.605h41.80493a4.61034,4.61034,0,0,1,4.60525,4.605v57.31565a4.61034,4.61034,0,0,1-4.60525,4.605H476.29725A20.53574,20.53574,0,0,1,455.78459,583.39527Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#fff"
      />
      <path
        d="M462.55334,553.54068a4.50491,4.50491,0,0,1,4.5-4.5h29a4.5,4.5,0,1,1,0,9h-29A4.50492,4.50492,0,0,1,462.55334,553.54068Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#e6e6e6"
      />
      <path
        d="M462.55334,567.54068a4.50491,4.50491,0,0,1,4.5-4.5h29a4.5,4.5,0,1,1,0,9h-29A4.50492,4.50492,0,0,1,462.55334,567.54068Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#e6e6e6"
      />
      <path
        d="M462.55334,581.54068a4.50491,4.50491,0,0,1,4.5-4.5h29a4.5,4.5,0,1,1,0,9h-29A4.50492,4.50492,0,0,1,462.55334,581.54068Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#e6e6e6"
      />
      <path
        d="M453.20233,580.34947a7.483,7.483,0,0,1-7.52827-8.65934l-41.5299-22.73929,12.15482-6.57378,38.48558,23.11419a7.52355,7.52355,0,0,1-1.58223,14.85822Z"
        transform="translate(-298.94666 -101.54068)"
        fill="#ffb8b8"
      />
      <path
        d="M429.05334,563.54068l-14.72691-2.6159-5.27309-4.3841-3.54647-1.80632-12.22271-8.57907-.03644-.10815-19.42136-57.4096a18.80383,18.80383,0,0,1,13.91455-21.73705h0a18.7836,18.7836,0,0,1,23.16841,15.86033l6.25027,49.20255,10.36061,10.69957,4.53314.87774,1.04347,4.88131,3.95653,6.11869Z"
        transform="translate(-298.94666 -101.54068)"
        fill={theme.text}
      />
    </svg>
  );
}
